export var activatedPopup_btn_understand = {
    key: 'app_logged_in::activatedPopup_btn_understand',
    fallback: "I UNDERSTAND"
};
export var activatedPopup_defaultEnv_isNow = {
    key: 'app_logged_in::activatedPopup_defaultEnv_isNow',
    fallback: "so your default environment is now "
};
export var activatedPopup_title_accountActivated = {
    key: 'app_logged_in::activatedPopup_title_accountActivated',
    fallback: "THIS  ACCOUNT HAS BEEN ACTIVATED"
};
export var activatePopup_link_goToActivation = {
    key: 'app_logged_in::activatePopup_link_goToActivation',
    fallback: "Go to Account Activation"
};
export var activatePopup_msg_activateAccount = {
    key: 'app_logged_in::activatePopup_msg_activateAccount',
    fallback: "Activate your account to gain\naccess to the Live environment"
};
export var activatePopup_msg_contactAccountManager = {
    key: 'app_logged_in::activatePopup_msg_contactAccountManager',
    fallback: "Contact your account manager to activate your account and gain access to the live environment"
};
export var activatePopup_msg_contactAdmin = {
    key: 'app_logged_in::activatePopup_msg_contactAdmin',
    fallback: "Contact your admin to activate the account and go live."
};
export var appCrash_msg_sorry = {
    key: 'app_logged_in::appCrash_msg_sorry',
    fallback: "We're sorry \u2014 something went wrong."
};
export var appCrash_msg_teamNotified = {
    key: 'app_logged_in::appCrash_msg_teamNotified',
    fallback: "Our team has been notified."
};
export var sidebar_menu_account = {
    key: 'app_logged_in::sidebar_menu_account',
    fallback: "Account"
};
export var sidebar_menu_activations = {
    key: 'app_logged_in::sidebar_menu_activations',
    fallback: "Activations"
};
export var sidebar_menu_analytics = {
    key: 'app_logged_in::sidebar_menu_analytics',
    fallback: "Analytics"
};
export var sidebar_menu_balances = {
    key: 'app_logged_in::sidebar_menu_balances',
    fallback: "Balances"
};
export var sidebar_menu_businessUnits = {
    key: 'app_logged_in::sidebar_menu_businessUnits',
    fallback: "Business Units"
};
export var sidebar_menu_dashboard = {
    key: 'app_logged_in::sidebar_menu_dashboard',
    fallback: "Dashboard"
};
export var sidebar_menu_decisionEngine = {
    key: 'app_logged_in::sidebar_menu_decisionEngine',
    fallback: "Decision Engine"
};
export var sidebar_menu_instantRetry = {
    key: 'app_logged_in::sidebar_menu_instantRetry',
    fallback: "Instant Retry"
};
export var sidebar_menu_locks = {
    key: 'app_logged_in::sidebar_menu_locks',
    fallback: "Locks"
};
export var sidebar_menu_paymentLinks = {
    key: 'app_logged_in::sidebar_menu_paymentLinks',
    fallback: "Payment Links"
};
export var sidebar_menu_payments = {
    key: 'app_logged_in::sidebar_menu_payments',
    fallback: "Payments"
};
export var sidebar_menu_paymentsSearch = {
    key: 'app_logged_in::sidebar_menu_paymentsSearch',
    fallback: "Search"
};
export var sidebar_menu_payouts = {
    key: 'app_logged_in::sidebar_menu_payouts',
    fallback: "Payouts"
};
export var sidebar_menu_providers = {
    key: 'app_logged_in::sidebar_menu_providers',
    fallback: "Providers"
};
export var sidebar_menu_reports = {
    key: 'app_logged_in::sidebar_menu_reports',
    fallback: "Reports"
};
export var sidebar_menu_settings = {
    key: 'app_logged_in::sidebar_menu_settings',
    fallback: "Settings"
};
export var sidebar_menu_settlements = {
    key: 'app_logged_in::sidebar_menu_settlements',
    fallback: "Settlements"
};
export var sidebar_menu_sftp = {
    key: 'app_logged_in::sidebar_menu_sftp',
    fallback: "SFTP Management"
};
export var sidebar_menu_transactionApproval = {
    key: 'app_logged_in::sidebar_menu_transactionApproval',
    fallback: "Transactions Approval"
};
export var sidebar_menu_transactionReports = {
    key: 'app_logged_in::sidebar_menu_transactionReports',
    fallback: "Reports"
};
export var sidebar_menu_treasury = {
    key: 'app_logged_in::sidebar_menu_treasury',
    fallback: "Treasury"
};
export var sidebar_menu_treasuryAnalytics = {
    key: 'app_logged_in::sidebar_menu_treasuryAnalytics',
    fallback: "Analytics"
};
export var sidebar_menu_userManagement = {
    key: 'app_logged_in::sidebar_menu_userManagement',
    fallback: "User Management"
};
export var sidebar_menu_virtualTerminal = {
    key: 'app_logged_in::sidebar_menu_virtualTerminal',
    fallback: "Virtual Terminal"
};
export var sidebar_menu_webhooks = {
    key: 'app_logged_in::sidebar_menu_webhooks',
    fallback: "Webhooks"
};
export var sidebar_menuLbl_configurations = {
    key: 'app_logged_in::sidebar_menuLbl_configurations',
    fallback: "Configurations"
};
export var topBar_lbl_docs = {
    key: 'app_logged_in::topBar_lbl_docs',
    fallback: "Docs"
};
export var topBar_lbl_previewTranslation = {
    key: 'app_logged_in::topBar_lbl_previewTranslation',
    fallback: "Preview Translations"
};
export var topBar_lbl_support = {
    key: 'app_logged_in::topBar_lbl_support',
    fallback: "Support"
};
export var topBar_popup_copySession = {
    key: 'app_logged_in::topBar_popup_copySession',
    fallback: "Copy Session Token To Clipboard"
};
export var topBar_popup_logout = {
    key: 'app_logged_in::topBar_popup_logout',
    fallback: "Logout"
};
export var topBar_popup_statusPage = {
    key: 'app_logged_in::topBar_popup_statusPage',
    fallback: "Status Page"
};
export var topBar_popup_supportTools = {
    key: 'app_logged_in::topBar_popup_supportTools',
    fallback: "Support & Developer Tools"
};
export var topBar_popup_switchAccount = {
    key: 'app_logged_in::topBar_popup_switchAccount',
    fallback: "Switch Account"
};
export var topBar_popup_userProfile = {
    key: 'app_logged_in::topBar_popup_userProfile',
    fallback: "User Profile"
};
export var topBar_switchProviderModal_content = {
    key: 'app_logged_in::topBar_switchProviderModal_content',
    fallback: "Are you sure you want to switch\nprovider to {{providerName}}?"
};
export var topBar_switchProviderModal_searchTooltipDecscription = {
    key: 'app_logged_in::topBar_switchProviderModal_searchTooltipDecscription',
    fallback: "Merchant Name;Account ID"
};
export var topBar_switchProviderModal_searchTooltipTitle = {
    key: 'app_logged_in::topBar_switchProviderModal_searchTooltipTitle',
    fallback: " will search in all of the following fields:"
};
export var topBar_switchProviderModal_title = {
    key: 'app_logged_in::topBar_switchProviderModal_title',
    fallback: "Switch Provider"
};
export var unsavedChanges_btn_leave = {
    key: 'app_logged_in::unsavedChanges_btn_leave',
    fallback: "Leave"
};
export var unsavedChanges_btn_stay = {
    key: 'app_logged_in::unsavedChanges_btn_stay',
    fallback: "Stay"
};
export var unsavedChanges_msg_content = {
    key: 'app_logged_in::unsavedChanges_msg_content',
    fallback: "Are you sure you want to continue?"
};
export var unsavedChanges_msg_header = {
    key: 'app_logged_in::unsavedChanges_msg_header',
    fallback: "All unsaved changes will be lost."
};
